import { call, take }   from 'redux-saga/effects';
import axios            from 'axios';
import makeStatement    from '../functions/makeStatement';

const endpoint = 'https://www.yisumatica.org.il/yisumaticaApiZvi/recordLrsStatementLive.php';
// const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/recordLrsStatementStage.php';

function* recordLrsEvent(): Generator<any, any, any> {
  // runs forever, listening for the action
  while (true) {
    try {
      // ────────────────────────────────────────────────────────────────────────────
      // Wait for the action and log the raw Redux action that arrived
      // ────────────────────────────────────────────────────────────────────────────
      console.log('[Saga] waiting for RECORD_LRS_EVENT_SAGA …');
      const input = yield take('RECORD_LRS_EVENT_SAGA');
      console.log('[Saga] action caught →', input);

      // Destructure the payload and log each piece
      const {
        appId,
        appName,
        appTopic,
        verb,
        userId,
        semelMosad,
        userName,
        tag,
        iri
      } = input.payload;

      console.log('[Saga] payload fields →', {
        appId,
        appName,
        appTopic,
        verb,
        userId,
        semelMosad,
        userName,
        tag,
        iri
      });

      // Detect dev / prod
      const dev = process.env.NODE_ENV === 'development';
      console.log(`[Saga] environment: ${dev ? 'development' : 'production'}`);

      // ────────────────────────────────────────────────────────────────────────────
      // Build the xAPI statement and log it
      // ────────────────────────────────────────────────────────────────────────────
      const statement = yield call(
        makeStatement,
        appId,
        appName,
        appTopic,
        userId,
        verb,
        tag,
        iri
      );
      console.log('[Saga] built statement →', statement);

      // Build the object sent to PHP and log it
      const obj = {
        statement,
        verb,
        appId,
        semelMosad,
        userName
      };
      console.log('[Saga] POST object →', obj);

      // ────────────────────────────────────────────────────────────────────────────
      // Do the POST (only in production) and log the response
      // ────────────────────────────────────────────────────────────────────────────
      if (!dev) {
        console.log(`[Saga] POSTing to ${endpoint}`);
        const res = yield call(axios.post, endpoint, obj);
        console.log('[Saga] response →', res);
      } else {
        console.log('[Saga] dev mode: skipping POST');
      }
    } catch (err) {
      console.error('[Saga] error →', err);
    } finally {
      // optional: log each loop completion
      console.log('[Saga] loop cycle complete ────────────────────────────────');
    }
  }
}

export default recordLrsEvent;
